import { useTheme } from '@mui/material/styles';
import { DownloadTray } from 'further-ui/components';
import Heading from 'components/Heading';
import { useBackgroundExports } from 'hooks/data/backgroundExports/useBackgroundExports';

const DownloadTrayContainer: React.FC = () => {
  const theme = useTheme();
  const {
    backgroundExports,
    downloadBackgroundExport,
    deleteBackgroundExport,
    retryBackgroundExport,
    acknowledgeBackgroundExports,
  } = useBackgroundExports();
  const exports = backgroundExports?.results ?? [];

  if (!exports.length) {
    return null;
  }

  return (
    <DownloadTray
      borderColor={theme.palette.borderColor.main}
      iconColor={theme.palette.common.brandColor}
      backgroundExports={exports}
      downloadBackgroundExport={(exportId: string) =>
        downloadBackgroundExport.mutate({ exportId })
      }
      deleteBackgroundExport={(exportId: string) =>
        deleteBackgroundExport.mutate({ exportId })
      }
      retryBackgroundExport={(exportId: string) =>
        retryBackgroundExport.mutate({ exportId })
      }
      acknowledgeBackgroundExports={() => acknowledgeBackgroundExports.mutate()}
      Heading={
        <Heading noMargin variant="h3">
          My downloads
        </Heading>
      }
    />
  );
};

export default DownloadTrayContainer;
